import { t } from '../../services/i18nService';

import * as idVerificationActions from '../../actions/IdVerificationActions';
import * as idVerificationConstants from '../../services/idverification/IdVerificationConstants';

const checkpointErrorDisplaySelector = {
    selectMessage(status) {
        /**
         * If there is no error message set, "Something went wrong" is the best
         * error message we can provide.
         *
         * I didn't use a ternary expression here because conditions and values
         * are too much lengthy to be readable.
         */
        if (
            !status
            || status === idVerificationActions.errorMessageTypes.requestWentWrong
        ) {
            return t(
                idVerificationConstants.internationalizationRequestWentWrongKey,
            );
        }

        if (this.isPoseNoFaceOrInvalidPhotoErrorMessageTypes(status)) {
            return t(
                `${idVerificationConstants.internationalizationErrorPrefix + status}Message`,
            );
        }

        return t(
            `${idVerificationConstants.internationalizationErrorPrefix + status}`,
        );
    },

    selectReason(status) {
        if (this.isPoseNoFaceOrInvalidPhotoErrorMessageTypes(status)) {
            return t(
                `${idVerificationConstants.internationalizationErrorPrefix + status}Reason`,
            );
        }

        return '';
    },

    isPoseNoFaceOrInvalidPhotoErrorMessageTypes(status) {
        return status === idVerificationActions.errorMessageTypes.noFacesDetected ||
            status === idVerificationActions.errorMessageTypes.wrongPose ||
            status === idVerificationActions.errorMessageTypes.tooDark ||
            status === idVerificationActions.errorMessageTypes.tooBlurry;
    },

    mapPropsToProps(props) {
        return {
            message: this.selectMessage(props.status),
            reason: this.selectReason(props.status),
        };
    },
};

export default checkpointErrorDisplaySelector;
